export default __webpack_public_path__ + "static/media/bg24.1c917cb0.jpg";